import { FC, useEffect, useState } from 'react'
import { ID, KTCard, KTCardBody, QUERIES } from '../../../../_dashboard/helpers'
import { PageDetailstoolbar } from './commun-component/PageDetailstoolbar'
import { PageDetailstoolbarSlider } from './commun-component/PageDetailstoolbarSlider'

import { Attribute, BlockComponent } from './commun-component/SectionComponent'
import { SliderComponent } from './commun-component/SliderComponent'

import { getOneById, getOneByIdbylang, updateOne } from '../../../services/common_requests'
import {toast} from 'react-toastify'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { SectionEditModal } from './pages-details-edit-modal/SectionEditModal'
import StickyLanguageSelector from '../../../components/StickyLanguageSelector'
import { SliderEditModal } from './pages-details-edit-modal/SliderEditModal'

interface Section {
  _id: ID
  title: string
  position: number
  slider: Slider
  attributes: any[]
  translations: {
    language: string
    title: string
    subtitle: string
    content: string
  }[]
}
interface Slider {
  _id: string; 
  blockId: string; 
  name: string; 
  time: number; 
  items: string[]; 
  isActive: boolean; 
  __v: number; 
}
type Props = {
  id: ID
}

const PageInfo: FC<Props> = () => {
  const { id } = useParams<{ id: any }>()
  const [sections, setSections] = useState<Section[]>([])
  const [slider, setSlider] = useState<Slider[]>([])

  const [showSectionModal, setShowSectionModal] = useState(false)
  const handleCloseModal = () => {
    setShowSectionModal(false)
  }
  const [selectedLanguage, setSelectedLanguage] = useState('fr')

  const [selectedSectionId, setSelectedSectionId] = useState<ID | null>(null)
  const [selectedSectionIdSlider, setSelectedSectionIdSlider] = useState<ID | null>(null)

  const [forceRender, setForceRender] = useState(false)  // Add this line to define the state for force rendering

  const intl = useIntl()
  console.log('sections',sections)
  console.log('sections filter',sections
    ?.filter(section => section.slider) )

  const handleAddSection = () => {
    setSelectedSectionId('new' as unknown as ID)
  }
  const handleAddSlider = () => { 
    setSelectedSectionIdSlider('new' as unknown as ID)
  }
  const { data: dataResponse, refetch } = useQuery(
    [QUERIES.SECTION_LIST, id],
    () => getOneByIdbylang(`/pages/${id}?language=all`),
    {
      refetchOnWindowFocus: false,
      enabled: !!id,
      onSuccess: (data) => setSections(data?.blocks || [])
    }
  )
  
  useEffect(() => {
    setSections(dataResponse?.blocks || [])
  }, [dataResponse])

  const handleAttributeAdded = (updatedBlockId: string, newAttribute: Attribute) => {
    setSections((prevSections) =>
        prevSections.map((section) =>
            String(section._id) === String(updatedBlockId)
                ? { 
                    ...section, 
                    attributes: [...section.attributes, { ...newAttribute }]
                }
                : section
        )
    )
    
  }

  const handleAttributeDeleted = (updatedBlockId: string, deletedAttributeId: string) => {
    setSections((prevSections) =>
        prevSections.map((section) =>
            String(section._id) === String(updatedBlockId)
                ? { 
                    ...section, 
                    attributes: section.attributes.filter(
                        (attr: Attribute) => String(attr._id) !== String(deletedAttributeId)
                    )
                }
                : section
        )
    );
};

  

  useEffect(() => {
    if (dataResponse?.blocks) {
      setSections(dataResponse?.blocks || []);
    }
  }, [dataResponse?.blocks]);

  return (
    <>
      <KTCard>
        <KTCardBody className='py-4'>
          <StickyLanguageSelector
            selectedLanguage={selectedLanguage}
            onLanguageChange={setSelectedLanguage}
          />
          <PageDetailstoolbarSlider onAddSlider={handleAddSlider} />
          {selectedSectionIdSlider !== null && (
            <SliderEditModal
              sectionId={selectedSectionIdSlider}
              pageId={id}
              onClose={() => setSelectedSectionIdSlider(null)}
            />
          )}
          {sections
            ?.filter(section => section.slider) 
            .map((section: Section) => (
            <SliderComponent 
              key={section._id} 
              block={section}
              pageId={id}
              selectedLanguage={selectedLanguage}
              handleAttributeAdded={handleAttributeAdded} 
              />
          ))}

          <PageDetailstoolbar onAddSection={handleAddSection} />
          {selectedSectionId !== null && (
            <SectionEditModal
              sectionId={selectedSectionId}
              pageId={id}
              onClose={() => setSelectedSectionId(null)}
            />
          )}
          {sections
          ?.filter(block => !block.slider)
          .map((section: Section) => (
            <BlockComponent 
              key={section._id} 
              block={section}
              pageId={id}
              selectedLanguage={selectedLanguage}
              handleAttributeAdded={handleAttributeAdded} 
              handleAttributeDeleted={handleAttributeDeleted}
              />
          ))}
        </KTCardBody>
      </KTCard>
    </>
  )
}

export { PageInfo }
